module.exports = __webpack_public_path__ + "static/img/12.56d246f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/12.png
// module id = wkQf
// module chunks = 0